import { render, staticRenderFns } from "./bread-charts.vue?vue&type=template&id=5e7e130c&scoped=true"
import script from "./bread-charts.vue?vue&type=script&lang=ts"
export * from "./bread-charts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7e130c",
  null
  
)

export default component.exports